export default __webpack_public_path__ + "images/assets/2fe785dbcec70fe2f66ae2a2fe5a1455.svg";